import React, { useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import editReducer, { defaultState, setRenewDataCreator, updateFieldCreator } from './reducer';
import { createIpmaCisCreator } from '../../../../../store/actionsCreators';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Button, Col, Container, Field, Heading, Row, PageContent } from 'components';
import { Margin } from 'styled-components-spacing';
import { toApiDate } from 'helpers/date';

function RenewIpmaDeltaCertificate({ deltaCertificate, renewDeltaCertificate }) {
  const { t } = useTranslation();
  const history = useHistory();
  const [state, dispatch] = useReducer(editReducer, defaultState);

  const handleChangeField = (name) => (e) => {
    dispatch(updateFieldCreator({ name, value: e.target.value }));
  };

  const submit = () => {
    const params = new FormData();
    params.append('certId', state.certId);
    params.append('deltaClass', state.deltaClass);
    params.append('status', state.status);
    params.append('organization', state.organization);
    params.append(
      'validTill',
      state.validTill ? toApiDate(state.validTill) : undefined,
    );
    params.append(
      'dateDeltaCertificate',
      state.dateDeltaCertificate
        ? toApiDate(state.dateDeltaCertificate)
        : undefined,
    );

    renewDeltaCertificate(params, history);
  };

  useEffect(() => {
    if (deltaCertificate) {
      dispatch(setRenewDataCreator(deltaCertificate));
    }
  }, [deltaCertificate]);

  return (
    <PageContent>
      <Container>
        <form>
          <Margin bottom="24">
            <Heading size="h5">
              {t('page.user.cis.deltaCertificates.renewDeltaCertificate')}
            </Heading>
          </Margin>
          <Margin bottom="24">
            <Heading size="h6">{t('page.user.cis.deltaCertificates.chooseToUpdateCertId')}</Heading>
          </Margin>
          <Row>
            <Col size={{ xl: 2 / 3 }}>
              <Margin bottom="20">
                <Field id="certId" label={t('page.user.cis.deltaCertificates.certId')} required>
                  <input
                    id="certId"
                    type="text"
                    placeholder={t('page.user.cis.deltaCertificates.certIdPlaceholder')}
                    value={state.certId}
                    onChange={handleChangeField('certId')}
                  />
                </Field>
              </Margin>
            </Col>
            <Col size={{ xl: 1 / 3 }}>
              <Margin bottom={{ xs: 12, md: 0 }}>
                <Button type="button" onClick={() => submit()}>
                  {t('global.confirmButton')}
                </Button>
              </Margin>
            </Col>
          </Row>
        </form>
      </Container>
    </PageContent>
  );
}

RenewIpmaDeltaCertificate.propTypes = {
  deltaCertificate: PropTypes.shape({
    certId: PropTypes.number,
    status: PropTypes.string,
    deltaClass: PropTypes.number,
    dateDeltaCertificate: PropTypes.any,
    validTill: PropTypes.any,
    organization: PropTypes.number,
  }),
  renewDeltaCertificate: PropTypes.func.isRequired,
};

RenewIpmaDeltaCertificate.defaultProps = {
  deltaCertificate: {},
};

const mapStateToProps = ({ ipma }) => ({
  deltaCertificate: ipma.cis.deltaCertificates.profile,
});

const mapDispatchToProps = (dispatch) => ({
  renewDeltaCertificate: (payload, history) =>
    dispatch(createIpmaCisCreator('deltaCertificates', payload, history)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RenewIpmaDeltaCertificate);
